import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import { MenuGroup } from 'Models/cadastros/Menu'
import ApiService from 'Services/ApiService'

const menu = {
  getItens: async (): Promise<AxiosResponse<MenuGroup[]>> => {
    const result: AxiosResponse<MenuGroup[]> = await ApiService().get<
      MenuGroup[]
    >(`${hosts.WS_CADASTRO}/menu`)

    return result
  },
}

export default menu
